// extracted by mini-css-extract-plugin
export var deleteModal = "_i4-0";